"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timeline = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var UseLoadMore_1 = require("Analytics/Page/Components/UseLoadMore");
var AnalyticsEmptyState_1 = require("../EmptyState/AnalyticsEmptyState");
var styles = __importStar(require("./Timeline.css"));
var Timeline = function (_a) {
    var timeZone = _a.timeZone, timelineData = _a.timelineData, renderEventCard = _a.renderEventCard, getEventIcon = _a.getEventIcon;
    if (!timelineData) {
        return react_1.default.createElement(kaleidoscope_1.Spinner, { primary: true });
    }
    return (react_1.default.createElement(LoadedTimeline, { timelineData: timelineData, timeZone: timeZone, renderEventCard: renderEventCard, getEventIcon: getEventIcon }));
};
exports.Timeline = Timeline;
var LoadedTimeline = function (_a) {
    var timelineData = _a.timelineData, timeZone = _a.timeZone, renderEventCard = _a.renderEventCard, getEventIcon = _a.getEventIcon;
    var _b = (0, UseLoadMore_1.useLoadMore)(timelineData, {
        initialItemCount: 5,
        increment: 10,
    }), itemsToShow = _b.itemsToShow, loadMoreButtons = _b.loadMoreButtons;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { align: "center" },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.timeline }, timelineData.length === 0 ? (react_1.default.createElement(AnalyticsEmptyState_1.AnalyticsEmptyState, { title: "No events in this time range" })) : (timelineData.slice(0, itemsToShow).map(function (rowData, index) {
            return (react_1.default.createElement("div", { key: rowData.key, className: styles.timelineRow },
                react_1.default.createElement(TimeComponent, { timeStamp: rowData.timeStamp, timeZone: timeZone }),
                react_1.default.createElement("div", { className: styles.iconAndConnectorLines },
                    react_1.default.createElement(ConnectorLines, { isLast: index === timelineData.length - 1 }),
                    react_1.default.createElement(EventIcon, { icon: getEventIcon(rowData) })),
                react_1.default.createElement(kaleidoscope_1.Card, { className: styles.eventCard }, renderEventCard(rowData))));
        }))),
        loadMoreButtons));
};
var TimeComponent = function (_a) {
    var timeStamp = _a.timeStamp, timeZone = _a.timeZone;
    var formattedDate = new Intl.DateTimeFormat(undefined, {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric",
        timeZone: timeZone,
    }).format(timeStamp);
    var formattedTime = new Intl.DateTimeFormat(undefined, {
        timeStyle: "short",
        hourCycle: "h12",
        timeZone: timeZone,
    }).format(timeStamp);
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.timeComponent, align: "end", paddingTop: "s" },
        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", lineHeight: "compact" }, formattedDate),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, formattedTime)));
};
var ConnectorLines = function (_a) {
    var isLast = _a.isLast;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles.horizontalConnectorLine }),
        !isLast && react_1.default.createElement("div", { className: styles.verticalConnectorLine })));
};
var EventIcon = function (_a) {
    var icon = _a.icon;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.eventIconFrame, align: "center", justify: "center" }, icon));
};
